import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, notification } from 'antd';
import axios from 'axios';
import { authenticate, isAuth } from '../../helpers/auth';
import './auth.css';

const SignIn = ({ history }) => {
  const [buttonLoading, setButtonLoading] = useState(false);

  const onFinish = (values) => {
    setButtonLoading(true);
    axios
      .post(`/api/signin`, values)
      .then((response) => {
        setButtonLoading(false);
        authenticate(response, () => {
          if (isAuth() && isAuth().role === 'user') { history.push('/admin/home/tafseer-quran'); }
          if (isAuth() && isAuth().role === 'bukhari') { history.push('/admin/home/sahi-bukhari'); }
          if (isAuth() && isAuth().role === 'admin') { history.push('/admin'); }
        });
      })
      .catch((error) => {
        notification.error({
          message: error.response.data.error,
        });
        setButtonLoading(false);
      });
  };

  const onFinishFailed = () => {};

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
            </svg>
          </div>
          <h1 className="auth-logo-title">Sakeenat Institute</h1>
          <p className="auth-logo-subtitle">Sign in to access lectures</p>
        </div>

        <Form
          name='basic'
          layout='vertical'
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label='Email'
            name='email'
            rules={[{ required: true, message: 'Please input your email!', type: 'email' }]}
          >
            <Input placeholder='Enter your email' />
          </Form.Item>

          <Form.Item
            label='Password'
            name='password'
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder='Enter your password' />
          </Form.Item>

          <Form.Item>
            <button disabled={buttonLoading} className='auth-submit-btn' type="submit">
              {buttonLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </Form.Item>
        </Form>

        <div className="auth-footer">
          <Link to='/' className="auth-back-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
            </svg>
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignIn;